import { h, Component } from 'preact';
import { FlyoutContainer } from '../../shared/flyout';
import { ThemedMoreNav } from '../more-nav';
import { ThemedTopicNav } from '../topic-nav';
import styles from './styles.scss';
import { wrapper } from '../buzzfeed_header.scss';
import { withTheme } from '../../shared/withTheme';

class MainNav extends Component {
  render({
    navItems,
    theme,
    showMoreNav,
    isSticking,
    showNotifMenu,
    top,
    children,
  }) {
    return (
      <div
        className={`${styles.mainNavContainer} ${theme.mainNavContainer} js-main-nav
          ${isSticking ? styles.stickyMainNav : ''}
          ${isSticking && !showNotifMenu ? styles.animateIn : ''}
        `}
        style={{ '--headerNavOffsetTop': `${top + 'px'}` }}
      >
        <div className={wrapper}>
          <div className={styles.mainNav}>
            {children}
            <ThemedTopicNav topics={navItems.topics} isSticking={isSticking} />
          </div>
          <ThemedMoreNav navItems={navItems} isVisible={showMoreNav} />
        </div>
        <FlyoutContainer />
      </div>
    );
  }
}

export const ThemedMainNav = withTheme(MainNav);
